import { getWeekSeconds } from "./getWeekSeconds";
import { DayIndex } from "@kanpla/types";

export const getDayIndexFromSeconds = (seconds: number) => {
  const mondaySeconds = getWeekSeconds(seconds);
  const secondsDifference = seconds - mondaySeconds;
  const daysDifference = (secondsDifference / 86400) as DayIndex;
  return daysDifference;
};
